.section {
  padding-block: clamp(56px, 8vw, 96px);
  background: var(--bg-alt);
}

.head {
  max-width: 60ch;
  margin-bottom: clamp(32px, 5vw, 48px);
}
.head h2 {
  margin-top: 10px;
  font-size: var(--step-4);
}
.head p {
  margin-top: 14px;
  font-size: var(--step-1);
  color: var(--text-secondary);
  max-width: 60ch;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
}
@media (max-width: 700px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

.pillar {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.pillarNumber {
  font-size: var(--step-3);
  font-weight: 800;
  color: var(--color-blue-100);
  -webkit-text-stroke: 1.5px var(--action);
  line-height: 1;
}
.pillar h3 {
  font-size: 1.05rem;
  font-weight: 700;
}
.pillar p {
  font-size: 0.92rem;
  color: var(--text-secondary);
}
